import {CellItem} from "./cellItem";
import {ValidateResult} from "../../model/contentType";
import {XmlTagInfo} from "../xmlTagProvider";
import {textareaItemView} from "../../ui/items/textarea";
import {Vnode} from "mithril";

type Level = { label: string, color: string };

export class TextareaItem extends CellItem {

    public readonly thermometer: {step: number, levels: Level[]}|null = null;

    constructor(config: XmlTagInfo) {
        super(config);

        const tag = this.childrenTags.filter(t => t.tag === 'ProgressBar')[0];
        if (!tag) {
            return;
        }

        const type = tag.attributes.type;
        const step = Number(tag.attributes.wordStep);
        if (type !== 'THERMOMETER' || !step) {
            return;
        }

        const levelsTag = tag.children.filter((t: XmlTagInfo) => t.tag === 'levels')[0];
        if (!levelsTag) {
            return;
        }

        const levels: Level[] = levelsTag.children.map((t: XmlTagInfo) => t.attributes );
        if (levels.length < 2) {
            return;
        }

        this.thermometer = {
            step: step,
            levels: levels,
        };

    }

    static fromXml(config: XmlTagInfo) {
        return new TextareaItem(config);
    }

    getView():Vnode {
        return textareaItemView(this);
    }

    set(value: any) {
        this.setVariable(value);
        this.updateUnknowns();
        this.form.reValidate();
    }

    validate() {
        const value = this.getVariable();
        if (!this.textValueFilled(value) || !this.wordCount()) {
            return ValidateResult.errorResult();
        }
        // this.contentType is set ini init()
        return this.contentType!.validate(value);
    }

    public wordCount(): number {
        if (!this.getVariable()) {
            return 0;
        }
        if (!this.getVariable().trim()) {
            return 0;
        }
        return this.getVariable().trim().split(/\s+/).length;
    }
}